import { useNavigate, useParams } from "react-router-dom";
import GradeList from "../../instructor/studentGrid/sublist/gradelist";
import Transcript from "../../instructor/studentGrid/sublist/transcript";
import Activities from "../../instructor/studentGrid/sublist/activities";
import BookList from "../../instructor/studentGrid/sublist/booklist";
import Personality from "../../instructor/studentGrid/sublist/personality";
import Colleges from "../../instructor/studentGrid/sublist/colleges";
import Goalsettings from "../../instructor/studentGrid/sublist/goalsettings";
import AcademicAssessment from '../../instructor/studentGrid/sublist/academicAssessment'
import GlobalStudentAwardsList from '../../pages/common/globalstudentawardlist'
import GlobalStudentActivityList from '../../pages/common/globalstudentactivitylist'
import { useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { logopcp } from '../../imagepath'
import StudentInfoPdf from '../../instructor/studentGrid/studentInfoPdf'
import style from './studentprofile.module.css'
import StudentInfoBox from '../studentinfo/studentinfobox'

const ParentStudentProfile = () => {
	const [mobileMenu, setMobileMenu] = useState(false)
	const navigate = useNavigate()
	let { slug } = useParams()

	const componentRef = useRef()
	// const handlePrint = useReactToPrint({
	//   content: () => componentRef.current
	// })
	const handlePrint = useReactToPrint({
		content: () => {
			removeBorderClasses()
			return componentRef.current
		},
		onAfterPrint: () => {
			restoreBorderClasses()
		}
	})

	const removeBorderClasses = () => {
		const elements = document.querySelectorAll('.border.border-3.border-primary')
		const transcriptDiv = document.getElementById('transcript_div_pdf')
		transcriptDiv.classList.add('pdf_transcript_div')
		transcriptDiv.classList.remove('transcript_div')
		const pdfLogo = document.getElementById('pdf_logo')
		const studentInfoBox = document.getElementById('student-info-box')
		const studentInfoPdf = document.getElementById('studentInfoPdf')
		pdfLogo.style.display = 'block'
		studentInfoBox.style.display = 'none'
		studentInfoPdf.style.display = 'block'
		elements.forEach((element) => {
			element.classList.add('border-hidden')
			element.classList.remove('border', 'border-3', 'border-primary')
		})
	}

	const restoreBorderClasses = () => {
		const elements = document.querySelectorAll('.border-hidden')
		const pdfLogo = document.getElementById('pdf_logo')
		const transcriptDiv = document.getElementById('transcript_div_pdf')
		transcriptDiv.classList.remove('pdf_transcript_div')
		transcriptDiv.classList.add('transcript_div')
		const studentInfoBox = document.getElementById('student-info-box')
		const studentInfoPdf = document.getElementById('studentInfoPdf')
		pdfLogo.style.display = 'none'
		studentInfoBox.style.display = 'block'
		studentInfoPdf.style.display = 'none'
		elements.forEach((element) => {
			element.classList.add('border', 'border-3', 'border-primary')
			element.classList.remove('border-hidden')
		})
	}

	return (
		<>
			<div className="main-wrapper">
				<section className="course-content">
					<div className="container-fluid w-80">
						<div className="d-flex justify-content-between align-items-center">
							<div className="">
								<button onClick={() => navigate(-1)} className="btn btn-black btn-sm mb-2">
									{'<< Back'}
								</button>
							</div>
							<div className="widget-btn">
								<button onClick={handlePrint} className="btn btn-info-light next_btn">
									Print Page
								</button>
							</div>
						</div>
						<div className="card wish-card" ref={componentRef}>
							<div className="card-header">
								<div id="student-info-box">
									<StudentInfoBox slug={slug} taskshow={false} />
								</div>
								<img src={logopcp} className={`${style.pdfLogo} img-fluid pdf_logo`} id="pdf_logo" alt="Logo" style={{ display: 'none' }} />
								<div id="studentInfoPdf" style={{ display: 'none' }}>
									<StudentInfoPdf slug={slug} />
								</div>
							</div>
							{/* <div className="page-break">
                <Goalsettings slug={slug} />
              </div> */}
							<div className="page-break">
								<AcademicAssessment slug={slug} isProfile={true} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<Colleges slug={slug} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<GradeList slug={slug} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<Transcript slug={slug} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<GlobalStudentActivityList slug={slug} isStudent={true} show={false} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<GlobalStudentAwardsList slug={slug} isStudent={true} show={false} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<BookList slug={slug} />
							</div>
							<span className="border border-3 border-primary"></span>
							<div className="page-break">
								<Personality slug={slug} />
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	)
}

export default ParentStudentProfile;
